import _ from 'underscore'

import service from '../service/help'

const getQuestionRecommendList = ({ commit }) => {
  return new Promise((resolve, reject) => {
    return service.getQuestionRecommendList().then(list => {
      resolve(list)
    }, e => {
      reject(e)
    })
  })
}

const getQuestionListByCategory = ({ commit, state }, data ) =>  {
  console.log('data', data)
  return new Promise((resolve, reject) => {
    return service.getQuestionListByCategory(data).then(list => {
      resolve(list)
    }, e => {
      reject(e)
    })
  })
}

export default {
  getQuestionRecommendList,
  getQuestionListByCategory,
}
